import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

// tempexp_20853-start
interface ExcludeTariffsConfig {
    quotas?: number[];
}

type FeatureType = ExcludeTariffsConfig | undefined;

/** CLOUDWEB-20853: Скрытие тарифов 64/128 на Webview+Touch */
export const excludeTariffsMobileLanding: FeatureType = IS_MOBILE_BROWSER ? getFeature('exclude-tariffs-mobile-landing') : undefined;
// tempexp_20853-end
